import { useEffect } from 'react';
import { browserHistory } from 'react-router';

import { useAsyncValue, useRequestConnectedToAsyncValue } from '../../../../../hooks';
import { put } from '../../../../../redux/api';
import type { ProjectGroupRelease } from '../../../../../types';
import type { UpdateProjectGroupReleaseRequest } from '../../../../../../typings/api';

const updateRelease = async (groupId: string, releaseId: string, req: UpdateProjectGroupReleaseRequest) => {
  return put<UpdateProjectGroupReleaseRequest, ProjectGroupRelease>(`/api/project_group/${groupId}/release/${releaseId}`, req);
};

/**
 * useUpdateRelease is a hook for updating existing releases.
 */
function useUpdateRelease() {
  const asyncValue = useAsyncValue<ProjectGroupRelease>();
  //  TODO: looking to improve the typing for `request` in useRequestConnectedToAsyncValue so we don't need to do this,
  //  but at least it's typed correctly downstream.
  const onUpdateRelease = useRequestConnectedToAsyncValue(updateRelease, asyncValue) as unknown as typeof updateRelease;

  // After a release is updated, redirect the user to the group summary page.
  useEffect(() => {
    if (asyncValue.value) {
      browserHistory.push(`/projects/group/${asyncValue.value.projectGroupId}`);
    }
  }, [asyncValue.value]);

  return {
    isUpdatingRelease: asyncValue.isLoading,
    errors: asyncValue.errors,
    onResetErrors: asyncValue.empty,
    onUpdateRelease,
  };
}

export default useUpdateRelease;
